import {CSSProperties} from "react";
import {useContext} from "react";
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";

import {ModalContext} from "../ModalContext";

import * as styles from "./ModalCloseButton.module.css";

interface IModalCloseButtonProps {
    placement?: "left" | "right";
    variant?: "default" | "rounded";
    className?: string;
    fillColor?: string;
    wrapperColor?: string;
    size?: string;
    style?: CSSProperties;
    onModalClose?: () => void;
}

export const ModalCloseButton = (props: IModalCloseButtonProps) => {
    const {onModalClose} = useContext(ModalContext);

    const variant = props.variant ?? "default";

    const size = props.size ?? (variant === "rounded" ? "2.0" : "2.4");
    const fillColor = props.fillColor ?? (variant === "rounded" ? "var(--colors-dark-4)" : "var(--colors.secondary)");
    const backgroundColorValue = props.wrapperColor ?? (variant === "rounded" ? "var(--colors-white)" : "transparent");

    const cn = classNames(props.className, styles.base, props.placement && styles[props.placement], variant === "rounded" && styles.rounded);

    return (
        <div role="button" onClick={props.onModalClose || onModalClose} className={cn} style={{...props.style, backgroundColor: backgroundColorValue}}>
            <CloseIcon size={size} wrapperSize={size} wrapperColor={props.wrapperColor} fill={fillColor} />
        </div>
    );
};
import {CSSProperties} from "react";
import {useContext} from "react";
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";

import {ModalContext} from "../ModalContext";

import * as styles from "./ModalCloseButton.module.css";

interface IModalCloseButtonProps {
    placement?: "left" | "right";
    variant?: "default" | "rounded";
    className?: string;
    fillColor?: string;
    wrapperColor?: string;
    size?: string;
    style?: CSSProperties;
    onModalClose?: () => void;
}

export const ModalCloseButton = (props: IModalCloseButtonProps) => {
    const {onModalClose} = useContext(ModalContext);

    const variant = props.variant ?? "default";

    const size = props.size ?? (variant === "rounded" ? "2.0" : "2.4");
    const fillColor = props.fillColor ?? (variant === "rounded" ? "var(--colors-dark-4)" : "var(--colors.secondary)");
    const backgroundColorValue = props.wrapperColor ?? (variant === "rounded" ? "var(--colors-white)" : "transparent");

    const cn = classNames(props.className, styles.base, props.placement && styles[props.placement], variant === "rounded" && styles.rounded);

    return (
        <div role="button" onClick={props.onModalClose || onModalClose} className={cn} style={{...props.style, backgroundColor: backgroundColorValue}}>
            <CloseIcon size={size} wrapperSize={size} wrapperColor={props.wrapperColor} fill={fillColor} />
        </div>
    );
};
